import React from 'react';

export interface NoResultProp {
  query: string;
}

export default function NoResult({ query }: NoResultProp) {
  return (
    <div className='mt-[85px] text-center'>
      <h2 className='mb-[30px] font-bold text-neutral-800'>
        No search result for &lsquo;{query}&rsquo;
      </h2>
      <p className='text-base'>
        Click &lsquo;Add contact&rsquo; to create a profile for &lsquo;
        {query}&rsquo;
      </p>
    </div>
  );
}
